import * as React from 'react';
import { CheckIcon } from 'lucide-react';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, checked, onCheckedChange, ...props }, ref) => {
    return (
      <span className="relative inline-flex h-4 w-4 cursor-pointer items-center justify-center">
        <input
          ref={ref}
          type="checkbox"
          className="peer absolute h-4 w-4 cursor-pointer appearance-none rounded border border-primary ring-offset-background checked:bg-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          checked={checked}
          onChange={(e) => onCheckedChange?.(e.target.checked)}
          {...props}
        />
        {checked && (
          <CheckIcon className="pointer-events-none absolute h-3 w-3 text-primary-foreground" />
        )}
      </span>
    );
  }
);
Checkbox.displayName = 'Checkbox';

export { Checkbox };
